/**
 * アコーディオン関連 Class
 */
export default class Accordion {
	constructor() {
		this.faq();
	};

	/**
	 * FAQアコーディオン
	 */
	faq() {
		$(document).on('click', '.js-faq-item', function () {
			if ($(this).hasClass('is-open')) {
				$(this).removeClass('is-open');
				$(this).children('.p-faq-section__item-anser').slideUp();
			} else {
				$(this).addClass('is-open');
				$(this).children('.p-faq-section__item-anser').slideDown();
			}
		});
	};
}
